var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bank_box"},_vm._l((_vm.cellValue),function(pspObj){return _c('a',{key:pspObj.pspTlId,staticClass:"link_element",on:{"click":function($event){$event.preventDefault();return _vm.handleClick(pspObj, $event)}}},[_vm._v(" "+_vm._s(_vm.formatDisplayText(pspObj.display))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }